export default "__VITE_ASSET__f5800c79__"